import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    PurchaseOrder,
    UpgradeItemType,
    UpgradeLabourType,
    UpgradeStoreTypeSetting,
    UpliftRequest
} from '@app/models/closedown-detail.model';
import { catchError, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseService } from '../base/base.service';

@Injectable({
    providedIn: 'root'
})
export class InvoiceService extends BaseService {
    readonly BASE_URL = `${environment.gatewayAPI_V1}/Invoices/`;
    //readonly BASE_URL = "https://localhost:7100/api/v1/";

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getUpliftPurchaseOrder(jobId: string, companyId: string): Observable<PurchaseOrder | null> {
        const url = `${this.BASE_URL}PurchaseOrder/GetUpliftPOByJobIdAndCompanyId`;
        const params = new HttpParams()
            .set('jobId', jobId)
            .set('companyId', companyId);

        return this.httpClient.get<PurchaseOrder | null>(url, { params }).pipe(
            catchError((error: HttpErrorResponse) => error.status === 404
                ? of(null)
                : this.handleError(error))
        );
    }

    public getUpgradeItemTypes(): Observable<UpgradeItemType[]> {
        const url = `${this.BASE_URL}PurchaseOrder/GetUpgradeItemTypes`;

        return this.httpClient.get<UpgradeItemType[]>(url).pipe(
            catchError(this.handleError)
        );
    }

    public getUpgradeLabourTypes(): Observable<UpgradeLabourType[]> {
        const url = `${this.BASE_URL}PurchaseOrder/GetUpgradeLabourTypes`;

        return this.httpClient.get<UpgradeLabourType[]>(url).pipe(
            catchError(this.handleError)
        );
    }

    public getUpgradeStoreTypeSettings(): Observable<UpgradeStoreTypeSetting[]> {
        const url = `${this.BASE_URL}/Invoices/getStoreTypeSettings`;

        return this.httpClient.get<UpgradeStoreTypeSetting[]>(url).pipe(
            catchError(this.handleError)
        );
    }

    public getUpgradeTaxRate(storeId: number): Observable<number> {
        const url = `${this.BASE_URL}/Invoices/GetInvoiceLineItemTaxRate`;
        const params = new HttpParams().set('storeid', storeId);

        return this.httpClient.get<number>(url, { params }).pipe(
            catchError(this.handleError)
        );
    }

    public createUpliftRequest(request: UpliftRequest): Observable<string> {
        const url = `${this.BASE_URL}PurchaseOrder/UpliftRequest`;

        return this.httpClient.post<string>(url, request).pipe(
            catchError(this.handleError)
        );
    }
}